import PropTypes from 'prop-types';

import { FlattenedNode } from './nodeShapes';

export var Renderer = {
  measure: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  node: PropTypes.shape(FlattenedNode)
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized-tree/es/shapes/rendererShapes.js
// module id = 245
// module chunks = 1